<div class="d-flex flex-row justify-content-between align-items-center">
    <sb-user-avatar [user]="reply.author"></sb-user-avatar>
    <span class="flex-fill text-break">{{ reply.author.name }}</span>
    <small class="text-light">{{ reply.creationTime | ticketEmailTime }}</small>
</div>
<br />
<div class="break-word message-html-content" [innerHTML]="reply.message | prepareMessage | replaceEmojis: true"></div>
@for (attachment of reply.attachments; track attachment; let index = $index) {
    <sb-file-preview
        class="file-container"
        [attachments]="reply.attachments"
        [attachment]="attachment"
        [fileIndex]="index"
        [reply]="reply">
    </sb-file-preview>
}
<div class="clearfix"></div>
